import type { FieldInputProps } from 'formik';
import type { NameAffix, NameAffixSuggestionsState } from './NameAffixField.types';

type NameAffixFormik = Readonly<{
  getFieldProps: (field: string) => FieldInputProps<string | undefined>;
  setFieldValue: (field: string, value: string) => unknown;
}>;

export const bindNameAffixField = (formik: NameAffixFormik, fieldName: string, affix: NameAffix, state: NameAffixSuggestionsState | undefined) => {
  const field = formik.getFieldProps(fieldName);
  return {
    affix,
    name: fieldName,
    value: field.value ?? '',
    onValueChange: (value: string) => formik.setFieldValue(fieldName, value),
    onBlur: field.onBlur,
    suggestions: state?.suggestions,
    isLoading: state?.loading,
  };
};
